import {API as axios} from "./../helpers/axios";

export const callsAPI  = {
    async updateCall(callId, payload) {
        return axios.patch(`/api/v1/widget/calls/${callId}`, {
                call: {
                    ...payload
                }
            },
            {
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            }
        );
    },

    async updateAgent(payload) {
        return axios.patch(`/api/v1/calls/update_agent`, {
                call: {
                    ...payload
                },
            },
            {
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            });
    },

    async createCall(payload) {
        return axios.post(`/api/v1/widget/calls`, {
                call: {
                    ...payload
                }
            },
            {
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            });
    }
};
